import React, { FC } from "react";
import classNames from "classnames";
import { ACCEPT_IMAGE_TYPES_STRING } from "constant-data";

import { emptyPhoto } from "utils/assets";

import styles from "./styles.module.css";

interface ImageUploadBoxProps {
  width: number;
  height: number;
  className?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
}

export const ImageUploadBox: FC<ImageUploadBoxProps> = ({
  width,
  height,
  className,
  onChange,
}) => (
  <label
    className={`${classNames(className, styles.container)}`}
    htmlFor="image-upload-box"
  >
    <img
      className={`w-${width} h-${height} rounded`}
      src={emptyPhoto}
      alt="image"
    />
    <input
      type="file"
      id="image-upload-box"
      className={styles.file_input}
      onChange={onChange}
      accept={ACCEPT_IMAGE_TYPES_STRING}
    />
  </label>
);
